import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * Reproduces views/balanceTransfer/simCard/from's onSubmit exactly, including
 * its two quirks — `daily_limit` is coerced to an int and `balance` is always
 * sent as 0 — so an inline save is equivalent to opening the dialog, changing
 * one field and pressing حفظ.
 *
 * Because the dialog discards it, `balance` is not editable here. Neither is
 * `is_active`: the table already toggles it through the dedicated
 * `changeStatus` endpoint via the status chip.
 */
export default defineInlineEdit({
  api: "simCard",
  permission: "sim_card_edit",
  hydrate: false,
  toPayload: (source) => ({
    id: source.id,
    type: source.type,
    name: source.name ?? "",
    phone: source.phone ?? "",
    imei: source.imei ?? "",
    port: source.port,
    code: source.code ?? "",
    is_active: source.is_active,
    daily_limit: parseInt(source.daily_limit),
    balance: 0,
  }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
    phone: {
      label: "رقم الهاتف",
      type: "text",
      required: true,
      inputProps: { inputMode: "tel", dir: "ltr" },
    },
    type: {
      label: "النوع",
      type: "options",
      required: true,
      options: [
        { value: "zain", label: "Zain" },
        { value: "asia", label: "Asia Cell" },
        { value: "korek", label: "Korek" },
      ],
    },
    imei: { label: "IMEI", type: "text", inputProps: { dir: "ltr" } },
    port: { label: "البورت", type: "number", required: true },
    code: { label: "الكود", type: "text", inputProps: { dir: "ltr" } },
    daily_limit: {
      label: "الحد اليومي",
      type: "number",
      toPatch: (value) => ({ daily_limit: parseInt(value) }),
    },
  },
});
